<template>
  <div>
    <section class="hero is-info is-medium is-bold">

      <headerbar></headerbar>

       <div class="hero-body">
         <div class="container has-text-centered" >
           <h1 class="title">Neolivros, edições digitais</h1>
           <h2>
             <p></p>
             <p>A Neolivros dedica-se, desde 2001, à edição em formato digital (ebooks ou livros electrónicos). Criamos também audiolivros em português de obras que se encontram em domínio público.</p>
             <!-- <p>Aqui pode encontrar obras inéditas, de novos autores que aqui encontram uma forma simples e eficaz de divulgação do seu trabalho e também obras clássicas da literatura portuguesa, inseridas no domínio público, onde se integram nomes como Luís de Camões, Almeida Garrett, Eça de Queirós, entre muitos outros.</p> -->
             <p>Apoiem-nos no Patreon (<a href="https://www.patreon.com/neolivros">https://www.patreon.com/neolivros</a>).</p>
           </h2>
         </div>
       </div>

     </section>

     <vue-simple-spinner id="spinner" style="padding: 100px"></vue-simple-spinner>

     <div id="main_content">

     <div class="box cta">
       <p class="has-text-centered">
         <span class="tag is-warning has-text-left">Novo</span> Estamos a renovar o nosso portal! <br>Acompanha-nos ao longo dos próximos meses e fica atento às novidades.
       </p>
     </div>

    <section class="section">
       <div class="container">
           <h2 class="title">Novidades</h2>
           <p class="subtitle">Últimos lançamentos disponíveis em ebook (ePub e/ou PDF), agora também em livro impresso <i>(em textos seleccionados)</i>.</p>
       </div>
    </section>

    <section class="container">
     <div class="tile is-ancestor">
         <div class="tile is-parent" v-if="featured" v-for="book in filteredBooks" :key="book.created">
           <article class="tile is-child box">
             <div class="columns">
               <div class="column">
                 <figure class="image is-2by3">
                 <a v-bind:href="'/titulo/'+ book['.key']"><img class="book-cover" :src="book.cover"></a>
                 </figure>
               </div>
             </div>
             <div class="columns">
               <div class="column">
                 <h1 class="title is-4"><a v-bind:href="'/titulo/'+ book['.key']">{{book.title}}</a></h1>
                 <h2 class="subtitle is-5" v-if="book.authors"><span v-if="book.authors" v-for="auth in book.authors" v-bind:key="auth">{{auth}}<br></span></h2>
                 <div class="tags has-addons">
                   <span class="tag is-ebook-dark"><i class="fa fa-file-text" aria-hidden="true"></i>&nbsp;&nbsp;eBook</span>
                   <span class="tag is-ebook">Grátis</span>
                   &nbsp;
                   <span v-if="book.price_paper" class="tag is-book-dark"><i class="fa fa-book" aria-hidden="true"></i>&nbsp;&nbsp;Livro</span>
                   <span v-if="book.price_paper" class="tag is-book">{{book.price_paper}}€</span>
                 </div>
                 <p v-html="book.synopsis.split('</p>')[0].substring(0,230) + '... '"></p>
               </div>
             </div>
           </article>
         </div>
     </div>
     <hr class="hr" style="margin-bottom: 0;">
    </section>

    <section class="section">
       <div class="container">
           <h2 class="title">Destaques</h2>
       </div>
    </section>

     <section class="container">
      <div class="tile is-ancestor">
          <div class="tile is-parent" v-if="featured" v-for="book in featured" :key="book.title">
            <article class="tile is-child box">
              <div class="columns">
                <div class="column">
                  <figure class="image is-2by3">
                  <a v-bind:href="'/titulo/'+ book['.key']"><img class="book-cover" :src="book.cover"></a>
                  </figure>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <h1 class="title is-5"><a v-bind:href="'/titulo/'+ book['.key']">{{book.title}}</a></h1>
                  <h2 class="subtitle is-6" v-if="book.authors"><span v-if="book.authors" v-for="auth in book.authors" v-bind:key="auth">{{auth}}<br></span></h2>
                  <div class="tags has-addons">
                    <span class="tag is-ebook-dark"><i class="fa fa-file-text" aria-hidden="true"></i>&nbsp;&nbsp;eBook</span>
                    <span class="tag is-ebook">Grátis</span>
                    &nbsp;
                    <span v-if="book.price_paper" class="tag is-book-dark"><i class="fa fa-book" aria-hidden="true"></i>&nbsp;&nbsp;Livro</span>
                    <span v-if="book.price_paper" class="tag is-book">{{book.price_paper}}€</span>
                  </div>
                </div>
              </div>
            </article>
          </div>
      </div>
      <hr class="hr" style="margin-bottom: 0;">
     </section>

    <section class="container">
      <div class="intro column is-8 is-offset-2">
      </div>
      <div class="tile is-ancestor">
        <div class="tile is-4 is-vertical is-parent">
          <div class="tile is-child box">
            <p class="title"><i class="fa fa-book" aria-hidden="true"></i> <span class="is-size-4">ePub</span></p>
            <p>É o formato preferencial para dispositivos móveis, como <i>smartphones</i> ou leitores dedicados. Este formato é compatível com aplicações como <a href="https://play.google.com/store/apps/details?id=com.aldiko.android&hl=en">Aldiko</a> em Android e iBooks em iOS/macOS.</p>
          </div>
          <div class="tile is-child box">
            <p class="title"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> <span class="is-size-4">PDF</span></p>
            <p>O formato de documentos mais popular, preserva toda a formatação original, ideal para leitura no computador/tablet ou para impressão. É compatível com a generalidade dos sistemas, incluindo Windows, macOS e Linux.</p>
          </div>
        </div>
        <div class="tile is-parent">
          <div class="tile is-child box">
            <p class="title"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> <span class="is-size-4">Como publicar?</span></p>
            <p>Desde 2001 que a Neolivros se dedica à publicação de textos em formato digital, nos mais variados géneros: conto, poesia, romance, ensaio... Disponibiliza clássicos da literatura portuguesa e obras inéditas de novos autores que aqui encontram uma forma simples de divulgar o seu trabalho.</p>
            <p>A publicação na Neolivros é simples e acessível. As obras são disponibilizadas <i>online</i>, em formato digital, após um processo de selecção. Os direitos permanecem na posse do autor. O registo das obras, embora não seja obrigatório, é recomendado.</p>
            <p>Interessado em publicar na Neolivros? Contacta-nos para <strong>info@neolivros.com</strong>.</p>
          </div>
        </div>
      </div>
    </section>

    <footerbar></footerbar>
    </div>

     <div id="modal-ter" class="modal">
       <div class="modal-background"></div>
       <div class="modal-card">
         <header class="modal-card-head">
           <p class="modal-card-title">Modal title</p>
           <button class="delete" aria-label="close"></button>
         </header>
         <section class="modal-card-body">
           <!-- Content ... -->
         </section>
         <footer class="modal-card-foot">
           <button class="button is-success">Save changes</button>
           <button class="button">Cancel</button>
         </footer>
       </div>
     </div>
  </div>
</template>

<script>
import bookFilters from '@/mixins/bookFilters'
import { settingsRef, booksRef, featuredRef, navRef, mediaRef } from '../firebase_config'
import Spinner from 'vue-simple-spinner'
import Header from './Header'
import Foot from './Foot'
export default {
  name: 'home',
  components: {
    'headerbar': Header,
    'footerbar': Foot,
    'vue-simple-spinner': Spinner
  },
  data () {
    var self = this
    featuredRef.once('value').then(function (questionsSnapshot) {
      for (var key in questionsSnapshot.val()) {
        booksRef.child(key).once('value').then(function (booksSnapshot) {
          var book = booksSnapshot.val()
          book['.key'] = booksSnapshot.key
          self.featured.push(book)
        })
      }
    })
    return {
      'featured': [] // return empty array, will be populated after featuredRef loads
    }
  },
  mixins: [bookFilters],
  firebase: {
    // load settings as object instead of array (default)
    settings: {
      source: settingsRef,
      asObject: true
    },
    books: {
      source: booksRef.orderByChild('created'), // .limitToLast(3),
      asObject: false
    },
    feat: {
      source: featuredRef,
      asObject: false
    },
    nav: {
      source: navRef
    },
    media: {
      source: mediaRef
    }
  },
  beforeMount: function () {
    // this.selectedOption = this.$route.params.key
    // this.params.category.label = 'Conto'
    this.selectedState = 'published'
    this.maxBooks = 3
    this.reverseBooks = true
    // this.selectedOption = 'created'
    // this.sortOptions.created.reverse = this.sortOptions.created.reverse
  },
  updated: function () {
    document.dispatchEvent(new Event('render-event'))

    var elem = document.querySelector('#spinner')
    elem.parentNode.removeChild(elem)
    document.querySelector('#main_content').style.display = 'block'
  },
  computed: {
    loadLogo () {
      var i = this.media.length
      var url = null
      while (i--) {
        if (this.media[i].name === 'WebsiteLogo') {
          url = this.media[i].src
        }
      }
      return url
    }
  }
}

</script>

<style lang="scss" scoped>
p {
  margin-bottom: 1.1rem;
}
.book-cover {
  -webkit-box-shadow: 0 0 5px rgba(0,0,0,0.6);
  -moz-box-shadow: 0 0 5px rgba(0,0,0,0.6);
  box-shadow: 0 0 5px rgba(0,0,0,0.6);
}
.hero-body {
  font-size: 110%;
  background-image: url("/static/img/home6.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.hero-body h1 {
  font-size: 140%;
}
.hero-body h2 {
  font-size: 120%;
}
.hero.is-info .title {
    color: #fff;
}
.hero.is-info .container {
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue